module.exports = __webpack_public_path__ + "img/miyagikyo_banner.6de604d3.png";